import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Summary from "../../../components/Provider/Reception/Summary";
import Loading from "../../../components/shared/Loading";
import Layout from "../../../components/Provider/Layout";
import ProviderService from "../../../services/ProviderServices";
import SimpleModal from "../../../components/shared/MessageModal";

const ReceptionSummary = () => {
  const history = useHistory();
  const {
    location: {
      state: { processedCuds, sessionId, activeTab },
    },
  } = history;
  const [cancelWarning, setCancelWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUploadStatus, setImageUploadStatus] = useState(null);

  console.log({ sessionId });

  const handleSignature = async (image, charger) => {
    // el image es un base64 png
    try {
      setLoading(true);
      const { status } = await ProviderService.finalizeSession({
        sessionId: sessionId,
        charger,
        image,
      });
      setImageUploadStatus(status);
      if (status !== 200) {
        // TODO: if image dont upload.
        setLoading(false);
        return console.log("IMAGE_DONT_UPLOAD");
      }

      console.log({ status });

      localStorage.removeItem("receptionSession");
      setLoading(false);
      history.push("/recepcion", {
        showModalSuccess: true,
        activeTab,
      });
    } catch (e) {
      setLoading(false);
    }
  };

  const handleCancelSession = async () => {
    try {
      setLoading(true);
      const response = await ProviderService.deleteSession(sessionId);
      localStorage.removeItem("receptionSession");
      console.log(response);
      setCancelWarning(false);
      history.push("/recepcion", { activeTab });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Loading visible={loading} />
      <SimpleModal
        visible={cancelWarning}
        txtBtn1="SALIR"
        onClickBtn1={handleCancelSession}
        txtBtn2={"CONTINUAR"}
        onClickBtn2={() => {
          setCancelWarning(false);
        }}
        type={10}
        closeModal={() => setCancelWarning(false)}
        title={"¿Seguro que deseas cancelar?"}
      >
        <div className="modal-warning-message">
          <p>
            Los cambios <span>no serán guardados</span> y el proceso de{" "}
            {activeTab === 0 ? "despacho" : "devolución"} finalizará.
          </p>
        </div>
      </SimpleModal>
      <SimpleModal
        visible={
          typeof imageUploadStatus === "number" && imageUploadStatus !== 200
        }
        txtBtn1="Aceptar"
        type={10}
        closeModal={() => setImageUploadStatus(null)}
        onClickBtn1={() => setImageUploadStatus(null)}
        title={"Error al subir la firma?"}
      >
        <div className="modal-warning-message">
          <p>Ha ocurrido un error al subir la firma, intenta nuevamente.</p>
        </div>
      </SimpleModal>
      <Summary
        showSummary={true}
        activeTab={activeTab}
        processedCuds={processedCuds}
        onClickCancel={() => setCancelWarning(true)}
        handleSignature={handleSignature}
        goBack={() => history.push("/recepcion", { sessionId, activeTab })}
      />
    </Layout>
  );
};

export default ReceptionSummary;
